export const impuestosDTOAdapterEmpty = () => ({
  FacturaId: 0,
  Id: 0,
  CierreLote: 0,
  IdAfiliado: 0,
  PreCupon: 0,
  Litros: 0,
  PrecioITC: 0,
  PrecioIDC: 0,
  PrecioTasaMunicipal: 0,
  PrecioTasaHidrica: 0,
  TotalITC: 0,
  TotalIDC:0,
  TotalTasaMunicipal:0,
  TotalTasaHidrica:0,
  TotalServicio:0,
  PrecioMaximo: 0,
  CargaITC: false,
  Renglon: 0,
  IdServicio: 0,
  ServicioDescripcion: "",
  ServicioXBandera: "",
  ProvinciaId: 0,
  ProvinciaDescripcion: "",
  CodigoPostal: 0,
  LocalidadDescripcion: "",
  FechaDesde: new Date(),
  FechaHasta: new Date(),
  Declarado: 0,
});

export const impuestosPresentacionRequestUpdateAdapter = (dataForm: any, list:any) => ({
  PreCupon: dataForm.PreCupon,
  IdAfiliado: 0,
  IdServicio: dataForm.IdServicio,//int
  Litros: dataForm.Litros,//double
  PrecioITC: Number(parseFloat(dataForm.ItC_precio).toFixed(4)),
  TotalITC: 0,
  Id: 0,
  PrecioIDC: Number(parseFloat(dataForm.IdC_precio).toFixed(4)),
  PrecioTasaMunicipal: Number(parseFloat(dataForm.Tasa_municipal_precio).toFixed(4)),
  PrecioTasaHidrica: Number(parseFloat(dataForm.Tasa_hidrica_precio).toFixed(4)),
  Declarado: dataForm.Verificado,//int
  Fpa_id:0,
  IdProvincia:0,
  CodPostal:0,
  FechaPresentacion:new Date(),
  ListaImpuestos:list,
});
export const impuestosPresentacionRequestEmpty = (list:any) => ({
  PreCupon: 0,
  IdAfiliado: 0,
  IdServicio: 0,
  Litros: 0.0,
  PrecioITC: 0.0000,
  TotalITC: 0.0000,
  Id: 0,
  PrecioIDC: 0.0000,
  PrecioTasaMunicipal: 0.0,
  PrecioTasaHidrica: 0.0,
  Declarado: 0,
  Fpa_id:0,
  IdProvincia:0,
  CodPostal:0,
  FechaPresentacion:new Date(),
  ListaImpuestos:list,
});


export const ImpuestosDTOAdapter = (impuesto: any) => ({
  FacturaId: 0,
  Id: 0,
  CierreLote: 0,
  IdAfiliado: 0,
  PreCupon: impuesto.PreCupon,
  Litros: impuesto.Litros,
  PrecioITC: Number(parseFloat(impuesto.ItC_precio).toFixed(4)),
  PrecioIDC: Number(parseFloat(impuesto.IdC_precio).toFixed(4)),
  PrecioTasaMunicipal: Number(parseFloat(impuesto.Tasa_municipal_precio).toFixed(4)),
  PrecioTasaHidrica: Number(parseFloat(impuesto.Tasa_hidrica_precio).toFixed(4)),
  TotalITC: Number(parseFloat(impuesto.ItC_total).toFixed(4)),
  TotalIDC:0,
  TotalTasaMunicipal:0,
  TotalTasaHidrica:0,
  TotalServicio:0,
  PrecioMaximo: 0,
  CargaITC: false,
  Renglon: 0,
  IdServicio: impuesto.IdServicio,
  ServicioDescripcion: impuesto.ServicioDescripcion ?? "",
  ServicioXBandera: "",
  ProvinciaId: 0,
  ProvinciaDescripcion: "",
  CodigoPostal: 0,
  LocalidadDescripcion: "",
  FechaDesde: new Date(),
  FechaHasta: new Date(),
  Declarado: impuesto.Verificado,
});
